<script lang="ts">
  import type { ISelectDataItem } from '../../types'

	import { fade } from 'svelte/transition'
  import { createEventDispatcher, onMount } from 'svelte'
  import { clickOutside } from './../../../../../../../helpers/index.js'

  import MultipleCheckbox from '../MultipleCheckbox/MultipleCheckbox.svelte'

  export let title: string
  export let items: ISelectDataItem[]
  export let value: any

  const dispatch = createEventDispatcher()

  let isShowItems: boolean = false;
  let localFlows = items;

  const handleClearFlows = () => {
    dispatch('change', []);
  };
</script>

<div class="form-group">
  <div class="title">{title}</div>

  <div 
    class="select" 
    on:click={() => isShowItems = !isShowItems} 
    use:clickOutside
    on:click_outside={() => isShowItems = false}
  >
    {#if value.length}
      <div class="select-value">{ [...value].map(({ title }) => title).join(', ') }</div>
    {:else}
      <div class="select-value grey">Заполни тут...</div>
    {/if} 

    {#if isShowItems}
      <div 
        class="select-items" 
        transition:fade
        on:click|stopPropagation={() => {}}
      >
        {#each localFlows as item (item.pk)}
          <div class="checkbox-button">
            <MultipleCheckbox
              label={item.title}
              value={item}
              bind:bindGroup={value}
              on:change={() => dispatch('change')}
            />
          </div>
        {/each}
      </div>
    {/if}

    {#if value.length}
      <i class="icon-cross" on:click|stopPropagation={handleClearFlows} />
    {:else}
      <i class="icon-chevron-right" style:transform={`rotate(${isShowItems ? '90deg' : '0'})`} />
    {/if}
  </div>
</div>

<style lang="scss">
  i {
    position: absolute;
    right: 20px;
    top: 13px;
    font-size: 10px;
    transition: transform .3s;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .checkbox-button {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .form-group {
    margin-bottom: 16px;
  }

  .title {
    color: #30333D;
    font-size: 16px;
    font-weight: 600;
    line-height: 23px;
    letter-spacing: 0em;
    margin-bottom: 8px;
  }

  .select {
    position: relative;
    cursor: pointer;
  }

  .select-items {
    overflow-y: scroll;
    z-index: 999999999;
    max-height: 200px;
    width: 100%;
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    box-shadow: 0px 2px 8px 0px #10107A29;
    position: absolute;
    margin-top: 8px;
    background-color: white;
  }

  .select-value {
    border: 1px solid #B6C8F9;
    padding: 12px;
    background-color: white;
    outline: none;
    border-radius: 4px;
    width: 100%;
    box-sizing: border-box;
    font-size: 16px;
    line-height: 23px;
    letter-spacing: 0em;
    color: #30333D;
    min-height: 49px;
    font-weight: normal;

    &.grey {
      color: #5A5F6D99;
    }

    &::-ms-expand {
      display: none !important;
    }

    &::placeholder {
      color: #5A5F6D99;
      font-size: 16px;
      line-height: 23px;
      letter-spacing: 0em;
    }
  }
</style>